import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { ModalStatusEvent } from '../base'
import { Routing } from '../../modules/routing'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'profileCulture', {
  title: 'Mon profil culturel',
  skip: "Passer pour l'instant",
})

Locale.getInstance().registerKeySet('en', 'profileCulture', {
  title: 'My cultural profile',
  skip: 'Not now',
})

export interface LvcProfileCultureModal {}

export class LvcProfileCultureModal extends MinzeElement {
  modalId = MODALS.PROFILE_CULTURE_MODAL
  attrs = ['skippable']
  reactive: Reactive = [
    ['showCulture', false],
    ['cultureId', ''],
    ['modalTitle', Locale.getKey('profileCulture.title')],
    ['cultureLabel', ''],
    ['cultureDescription', ''],
    ['hasAnyCulture', false],
  ]

  onReady(): void | Promise<void> {
    this.updateViewWithProfile()
  }

  private async updateViewWithProfile(): Promise<void> {
    const mainModule = MainModule.getInstance()
    const auth = mainModule.getAuth()
    const userData = await auth.getUserData()
    const hasAnyCulture: boolean = !!userData?.profile?.culturalProfile
    this.hasAnyCulture = hasAnyCulture
    this.rerender()
  }

  onBack = () => {
    const frontendBreadcrumb = document.querySelector('.lvc-breadcrumb_component')
    frontendBreadcrumb?.removeAttribute('style')
    this.updateViewWithProfile()
    if (this.showCulture) {
      this.showCulture = false
      this.cultureId = ''
      this.cultureLabel = ''
      this.cultureDescription = ''
      this.modalTitle = Locale.getKey('profileCulture.title')
      return
    }

    if (this.skippable) {
      return
    }
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profile)
  }

  onSkip = async () => {
    const mainModule = MainModule.getInstance()
    const auth = mainModule.getAuth()
    //await auth.saveProfile("user-process", { hasCompletedProfile: true });
    this.parentElement?.removeChild(this)
  }

  handleModalEvent = (event: any) => {
    const detail = event?.detail
    const frontendBreadcrumb = document.querySelector('.lvc-breadcrumb_component')
    frontendBreadcrumb?.setAttribute('style', 'display: none')
    this.cultureId = detail.code
    this.cultureLabel = detail.label
    this.modalTitle = detail.label
    this.cultureDescription = detail.description
    this.showCulture = true
    this.rerender()
  }

  html = () => `
    <lvc-modal
      modal-id="${this.modalId}"
      left-title="true"
      narrow="true"
      show-when-logged="true"
      modal-title="${this.modalTitle}"
      is-fixed="false"
      is-fullscreen-modal-scrollable="true"
    >
      <div class="modal-top" slot="lvc-modal-top">
        ${
          this.showCulture
            ? `
        <lvc-box color="#1E007D" display="flex" alignItems="center" name="backButton">
          <lvc-chevron-left-icon></lvc-chevron-left-icon>
          <lvc-text font-preset="small">${Locale.getKey('general.previous')}</lvc-text>
        </lvc-box>
        `
            : ''
        }
        <div class="flexy"></div>
        <lvc-box color="#1E007D" display="flex" alignItems="center" name="skipButton">
          <lvc-text font-preset="small">${this.hasAnyCulture ? Locale.getKey('general.finish') : Locale.getKey('profileCulture.skip')}</lvc-text>
          <lvc-chevron-right-icon></lvc-chevron-right-icon>
        </lvc-box>
      </div>
      <div slot="lvc-modal-content">
        ${
          this.showCulture
            ? `<lvc-culture-category-modal-content data-culture-description="${this.cultureDescription}" data-id="${this.cultureId}" data-culture="${this.cultureLabel}"></lvc-culture-category-modal-content>`
            : `
        <lvc-profile-culture-modal-content></lvc-profile-culture-modal-content>
        `
        }
      </div>
    </lvc-modal>
    ${
      window.matchMedia('(max-width: 991px)').matches
        ? ''
        : `<lvc-cultural-profile-icon></lvc-cultural-profile-icon>`
    }
  `

  css = () => {
    const showSkip = this.skippable && !this.showCulture ? '' : 'display: none;'
    const showBack = this.showCulture || !this.skippable ? '' : 'display: none;'
    return `
      :host {

      }

      .flexy {
        flex: 1;
        flex: 1 0 1px;
      }
      .modal-top {
        display: flex;
        align-items: space-between;
      }

      lvc-cultural-profile-icon {
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: 10001;
        max-width: 27%;
      }

      [name="backButton"] {
        cursor: pointer;
        ${showBack}
      }
      [name="skipButton"] {
        cursor: pointer;
        ${showSkip}
      }
    `
  }

  eventListeners: EventListeners = [
    ['[name="backButton"]', 'click', this.onBack],
    ['[name="skipButton"]', 'click', this.onSkip],
    ['lvc-profile-culture-modal-content', 'category-selected', this.handleModalEvent],
  ]
}
